var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextStyleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6886_819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 8.75H0V10H1.25V8.75Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8.75H8.75V10H10V8.75Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0H8.75V1.25H10V0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 0H0V1.25H1.25V0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.3125H1.875V0.9375H2.5V0.3125Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 0.3125H3.125V0.9375H4.6875V0.3125Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 0.3125H5.3125V0.9375H6.875V0.3125Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 0.3125H7.5V0.9375H8.125V0.3125Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.0625H1.875V9.6875H2.5V9.0625Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 9.0625H3.125V9.6875H4.6875V9.0625Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 9.0625H5.3125V9.6875H6.875V9.0625Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 9.0625H7.5V9.6875H8.125V9.0625Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 2.5V1.875H9.0625V2.5H9.6875Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 4.6875V3.125H9.0625V4.6875H9.6875Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 6.875V5.3125H9.0625V6.875H9.6875Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 8.125V7.5H9.0625V8.125H9.6875Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 2.5V1.875H0.3125V2.5H0.9375Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 4.6875L0.9375 3.125H0.3125L0.3125 4.6875H0.9375Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 6.875L0.9375 5.3125H0.3125L0.3125 6.875H0.9375Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 8.125V7.5H0.3125V8.125H0.9375Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48287 7.69269L4.44155 2.30762H5.55822L7.5169 7.69269H6.36829L5.95996 6.55692H4.03287L3.63079 7.69269H2.48218H2.48287ZM4.42246 5.46595H5.56447L4.99641 3.87081L4.42211 5.46595H4.42246Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextStyleIcon);
export default __webpack_public_path__ + "static/media/TextStyleIcon.7fe420da700660fd3c56f6843bb8f786.svg";
export { ForwardRef as ReactComponent };